import BrandLogo from "@/components/BrandLogo";

/**
 * Footer for the super admin shell. Deliberately not the shared Footer: that one
 * links into buyer/member surfaces (Favorites, SBA Calculator, Deal CRM…) which
 * need a real signed-in portal account, so every one of those links would bounce
 * a super admin to /sign-in. Same visual language, super-admin-appropriate links.
 */
export default function SuperAdminFooter() {
  return (
    <footer className="mt-auto border-t border-border/80 bg-card/80 px-4 py-8 sm:px-6 lg:px-8">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-4">
        <BrandLogo className="h-10 w-auto" />
        <span className="text-xs text-muted-foreground">
          &copy; {new Date().getFullYear()} BusinessLocating Hub &middot; All rights reserved
        </span>

        <div className="ml-auto flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-muted-foreground">
          <span className="font-semibold uppercase tracking-[0.14em] text-primary">Super Admin Console</span>
          <a
            href="https://www.businesslocating.com/terms"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-foreground"
          >
            Terms &amp; Conditions
          </a>
          <a
            href="https://www.businesslocating.com/privacy"
            target="_blank"
            rel="noopener noreferrer"
            className="transition-colors hover:text-foreground"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}
